import { message } from "antd";
import api from "../api";

export const LocalidadeService = {

    getPaises: async (setLoading: Function) => {
        return await api.get("Localidade/getPaises").then((response) => {

            let paisesOrdenado = response.data.sort(function (a: any, b: any) {
                return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
            });

            return paisesOrdenado;

        }).finally(() => {
            setLoading(false);

        }).catch((error) => {
            message.warning("Erro inesperado");
        });
    },

    getEstados: async (setLoading: Function, paisName: string) => {

        setLoading(true);

        return await api.get(`Localidade/getEstado?paisName=${paisName}`).then((response) => {


            let estados = response.data.sort(
                function (a: any, b: any) {
                    return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                }
            );

            return estados;

        }).finally(() => {
            setLoading(false);

        }).catch((error) => {

            message.warning("Erro inesperado");
        });
    },


    getCidade: async (setLoading: Function, estadoName: string) => {

        setLoading(true);

        return await api.get(`Localidade/getCidade?estadoName=${estadoName}`).then((response) => {

            let cidades = response.data.sort(function (a: any, b: any) {
                return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
            });

            return cidades;

        }).finally(() => {

            setLoading(false);


        }).catch((error) => {
            message.warning("Erro inesperado");
        });
    }
}

